import API from '../../../../../services/api';
import { headers } from '../helpers/functionalities';

export const INCIDENCIAS_API = {
    get: async (page = 1, search = null) => {
        return await API.get(`/incidencias?page=${page}${search || null}`).then(res => res.data);
    },
    getById: async (incidenciaId) => {
        return API.get('/incidencias/' + incidenciaId).then(res => res.data);
    },
    new: async (incidencia) => {
        return API.post('/incidencias', incidencia).then(res => res.data);
    },
    assignAlternative:  async (incidencia) => {
        return API.post('/incidencias/' + incidencia.id + '/alternativa', incidencia).then(res => res.data);
    },
    changeResponsible: async (incidencia) => {
        return API.post('/incidencias/' + incidencia.id + '/responsable', incidencia).then(res => res.data);
    },
    changeSubStatus: async (incidencia) => {
        return API.post('/incidencias/' + incidencia.id + '/subestado', incidencia).then(res => res.data);
    },
    markAsForFinances: async (incidencia) => {
        return API.post('/incidencias/' + incidencia.id + '/finanzas', incidencia).then(res => res.data);
    },
    markAsActive: async (incidenciaId) => {
        return API.post('/incidencias/' + incidenciaId + '/activa', {}).then(res => res.data);
    },
    markAsFinished: async (incidenciaId) => {
        return API.post('/incidencias/' + incidenciaId + '/finalizada', {}).then(res => res.data);
    },
    getDocs: async (incidenciaId, documentacion) => {
        return API.post('/incidencias/' + incidenciaId + '/files', { documentacion }).then(res => res.data);
    },
    downloadDoc: async (incidenciaId, documento) => {
        return API.post('/incidencias/' + incidenciaId + '/download', documento, {responseType: 'blob'}).then(res => res.data);
    },
    uploadDocs: async (incidenciaId, documentos) => {
        return API.post('/incidencias/' + incidenciaId + '/upload_documentation', documentos, headers).then(res => res.data);
    },
    deleteDoc: async (incidenciaId, documento) => {
        return API.post('/incidencias/' + incidenciaId + '/delete_documentation', documento).then(res => res.data);
    },
    uploadPackageImg: async (incidenciaId, imgs) => {
        return API.post('/incidencias/' + incidenciaId + '/upload_imgs_paquete', imgs, headers).then(res => res.data);
    },
    deletePackageImg:  async (incidenciaId, img) => {
        return API.post('/incidencias/' + incidenciaId + '/delete_imgs_paquete', img).then(res => res.data);
    },
    exportLosses: async (filters) => {
        return API.post('/incidencias/export', filters, {responseType: 'blob'}).then(res => res.data);
    },
    exportRecomotorFault: async (filters) => {
        return API.post('/incidencias/export-culpa-recomotor', filters, {responseType: 'blob'}).then(res => res.data);
    },
    update: async (incidenciaId, incidencia) => {
        return API.put('/incidencias/' + incidenciaId, incidencia).then(res => res.data);
    },
    delete: async (incidenciaId) => {
        return API.delete('/incidencias/' + incidenciaId).then(res => res.data);
    }
}

export const VALES_DESCUENTO_API = {
    new: async (valeDescuento) => {
        return API.post('/vales-descuentos', valeDescuento).then(res => res.data);
    },
    send: async (valeDescuentoId) => {
        return API.post('/vales-descuentos/' + valeDescuentoId + '/enviar', {}).then(res => res.data);
    },
    update: async (valeDescuento) => {
        return API.put('/vales-descuentos/' + valeDescuento.id, valeDescuento).then(res => res.data);
    },
    delete: async (valeDescuentoId) => {
        return API.delete('/vales-descuentos/' + valeDescuentoId).then(res => res.data);
    }
}